import { ComponentStyleConfig } from '@chakra-ui/react';

export const AppLoader: ComponentStyleConfig = {
  baseStyle: {
    position: 'fixed',
    justifyContent: 'center',
    alignItems: 'center',
    width: '-webkit-fill-available',
    '@-moz-document url-prefix()': {
      width: ' -moz-available',
    },
    height: '100%',
    zIndex: 'calc(var(--chakra-zIndices-banner) + 1)',
    '@keyframes loading-animation': {
      '0%': {
        fill: 'iconBase',
      },
      '50%': {
        fill: 'white',
      },
      '100%': {
        fill: 'iconBase',
      },
    },

    '.loader': {
      width: '112px',
      height: '112px',
      '& path': {
        animation: 'loading-animation 2s infinite',
        webkitAnimation: 'loading-animation 2s infinite',
      },
    },
  },
  sizes: {},
  variants: {},
  defaultProps: {},
};
